<template>
  <div>
    <course-list-simplified
        :courses-source="allCoursesList"
        :present-courses="presentCourses"/>
  </div>
</template>
<script>
import CourseListSimplified from "@/components/Element/CourseListSimplified";

export default {
  name: 'selected-courses',
  components:{CourseListSimplified},
  computed: {
    presentCourses() {
      var courses = this.allSelectedCourses
      return courses
    },
  },
}
</script>
